export default __webpack_public_path__ + "static/media/jackson-so-_t-l5FFH8VA-unsplash.df97658b.jpg";